module.exports = __webpack_public_path__ + "static/media/python.b3efce84.png";